/**
 *  作者: 吕俊涛
 */
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MiddleSearchCriteria, RulesData, TopSearchCriteria } from './TopSearchCriteria';
import { formatDate } from '@angular/common';
import { PageRules, RulesConfig } from './PageRules';
import { JgridService } from './jgrid.service';
import { TadpoleTotalData } from './tadpoleTotalData';
import { ColumnModel } from './ColumnModel';
import { TopButtonGroup } from './TopButtonGroup';
import { QuicklySearch } from './QuicklySearch';
import { JGridConstant } from './JGridConstant';
import { WorkflowSearchBean } from './WorkflowSearchBean';
import { CommonsService } from '@core/service/commons.service';
import { Pagination } from '@core/bean/pagination';
import { PageData } from '@core/bean/page-data';

@Component({
  selector: 'app-jgrid',
  templateUrl: './jgrid.component.html',
  styleUrls: ['./jgrid.component.css'],
})

export class JgridComponent implements OnInit {

  @Input() topSearchCriteria: TopSearchCriteria[]; // 标签类型 input, date, rangeDate, rangeInput, select, dictSelect, browser, button
  @Input() middleSearchCriteria: MiddleSearchCriteria[]; // 标签类型 nzTag date
  @Input() colModels: ColumnModel[]; // 表格
  @Input() topButtonGroup: TopButtonGroup[]; //按钮
  @Input()
  displayCheckBox: boolean = false; // 显示勾选框
  @Input()
  checkType = JGridConstant.JGRID_CHECKBOX; // 单选/多选
  @Input() quicklySearch: QuicklySearch[]; // 全速搜索
  @Input() workflowSearchBean: WorkflowSearchBean = null; // workflow流程
  @Input() fixedRule: RulesConfig[]; // 默认搜索规则
  @Input() url: string; // url
  @Input() direction: string; // 排序规则
  @Input() property: string; // 按属性排序
  @Input() scrollX: string; // 表格宽度
  @Input() scrollY: string; // 表格高度
  @Input() selectedRows: string[]; // 选中的行
  @Input() selectedRowId: string[]; // 选中的行id
  @Input() pageSizeOptions: any; // 一页数据量
  @Input() foldBtn: boolean = true; // 展开收起按钮是否显示
  @Input() pagination: Pagination = null; // 调用原先pagination方式
  @Output() jgridPushRules = new EventEmitter(); // 抛出搜索字段
  @Output() buttonGroupClick = new EventEmitter(); // 按钮事件
  @Output() butGroupClick = new EventEmitter(); // 按钮事件
  @Output() tableOptionClick = new EventEmitter(); // 表格内按钮事件
  @Output() checkboxChange = new EventEmitter(); // 表格内选择框事件

  public rulesData: RulesData = {
    rules: [],
  }; // 标签类型 nzTag date
  public tadpoleSearchTop = [];
  public firstTadpoleSearchTop = [];
  public twoTadpoleSearchTop = [];
  public tadpoleSelectData = [];

  public tadpoleSearchData = {};
  public tadpoleRangeDate = {};
  public tadpoleDateData = {};
  public tadpoleTableData = [];

  public searchSwitch: boolean = true; // 显示隐藏

  public pageRules: PageRules;
  public number = 1;
  public size = 10;
  public tadpolePagData: any;
  public loading: boolean;
  public morBntData = []; // 隱藏的按鈕
  public diyButton = []; // diy按鈕
  public tadpoleTotalData: TadpoleTotalData = new TadpoleTotalData(0, []);
  public flagType = ['CREATE_', 'DELETE_', 'EXPORT_', 'IMPORT_', 'SYNC_ALL_', 'SYNC_CUSTOM_', 'REFRESH_'];
  public flagTypeObj = {
    'CREATE_': {
      icon: 'plus',
      name: 'commons.button.create',
    }, 'DELETE_': {
      icon: 'delete',
      name: 'commons.button.delete',
    }, 'EXPORT_': {
      icon: 'logout',
      name: 'commons.button.export',
    }, 'IMPORT_': {
      icon: 'commons.button.excelIn',
      name: 'login',
    }, 'SYNC_ALL_': {
      icon: 'swap',
      name: 'supplier.sup-ass.synchronizeAll',
    }, 'SYNC_CUSTOM_': {
      icon: 'swap',
      name: 'supplier.sup-ass.customsSynchronize',
    }, 'REFRESH_': {
      icon: 'retweet',
      name: 'commons.button.refresh',
    },
  };
  public that: any;
  //选择日期
  disabledStartDate = (startValue: Date): boolean => {
    if (!startValue || !this.tadpoleDateData['deliveryDate-le']) {
      return false;
    }
    return startValue.getTime() > this.tadpoleDateData['deliveryDate-le'].getTime();
  };
  disabledEndDate = (endValue: Date): boolean => {
    if (!endValue || !this.tadpoleDateData['deliveryDate-ge']) {
      return false;
    }
    return endValue.getTime() <= this.tadpoleDateData['deliveryDate-ge'].getTime();
  };
  public mouseOpen: boolean;
  public quicklySearData = [];
  public allChecked = false;
  public indeterminate = false;
  public multipleCheck = true;
  public selectedLength = { selectedLength: 0 };

  constructor(
    public commonsService: CommonsService,
    public tadpoleService: JgridService) {
  }

  ngOnInit(): void {
    this.that = this.commonsService;
    if (this.topSearchCriteria) {
      this.firstTadpoleSearchTop = [];
      this.twoTadpoleSearchTop = [];
      this.tadpoleSearchTop = this.topSearchCriteria; // 初始化数据
      if (this.tadpoleSearchTop.length > 2) {
        for (let i = 0; i < this.tadpoleSearchTop.length; i++) {
          if (i < 2) {
            this.firstTadpoleSearchTop.push(this.tadpoleSearchTop[i]);
          } else {
            this.twoTadpoleSearchTop.push(this.tadpoleSearchTop[i]);
          }
        }
      } else {
        this.firstTadpoleSearchTop = this.topSearchCriteria;
      }
      for (let i = 0; i < this.topSearchCriteria.length; i++) {
        if (this.topSearchCriteria[i]['defaultValue']) {
          this.rulesData.rules.push({
            field: this.topSearchCriteria[i]['searchName'],
            option: this.topSearchCriteria[i].option,
            values: [this.topSearchCriteria[i]['defaultValue']],
          });
          this.tadpoleSearchData[this.topSearchCriteria[i]['searchName']] = this.topSearchCriteria[i]['defaultValue'];
        }
      }
    }
    if (this.middleSearchCriteria) {
      this.tadpoleSelectData = this.middleSearchCriteria;
      for (let i = 0; i < this.tadpoleSelectData.length; i++) {
        if (this.tadpoleSelectData[i]['type'] == 'select' && this.tadpoleSelectData[i]['defaultValue']) {
          this.rulesData.rules.push({
            field: this.tadpoleSelectData[i]['searchName'],
            option: this.tadpoleSelectData[i].option,
            values: [this.tadpoleSelectData[i]['defaultValue']],
          });
          this.tadpoleSearchData[this.tadpoleSelectData[i]['searchName']] = this.tadpoleSelectData[i]['defaultValue'];
        }
      }
    }
    if (this.selectedRows) {
      this.selectedRows = [];
    }
    if (this.selectedRowId) {
      this.selectedRowId = [];
    }
    if (this.colModels) {
      this.tadpoleTableData = this.colModels;
    }
    this.tadpoleService.url = this.url;
    this.pageSizeOptions = this.pageSizeOptions || [10, 20, 50, 100];
    if (this.topButtonGroup) {
      this.topButtonGroup.forEach(item => {
        if (item['butType']) {
          this.diyButton.push(item);
        }
        if (item['hidden']) {
          this.morBntData.push(item);
        }
      });
    }
    if (this.quicklySearch) {
      this.quicklySearData = [];
      this.quicklySearData.push(this.quicklySearch[0]['condition']);
    }
    this.loading = true;
    this.getTadpoleData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.pagination) {
      this.ngOnInit();
    }
  }

  /**
   * 点击浏览按钮
   *  @param result 浏览框返回数据
   *  @param info 配置信息 searchName 搜索字段
   * */
  selectBrowse(result, info) {
    this.tadpoleSearchData[info['searchName']] = result[info['browseParamValue']];
  }

  /**
   * 清除浏览按钮
   * */
  clearBrowse(info) {
    this.tadpoleSearchData[info['searchName']] = null;
  }

  /**
   * 收起 / 展开按钮
   * */
  searchChange() {
    this.searchSwitch = !this.searchSwitch;
  }

  mouseOverEven() {
    this.mouseOpen = true;
  }

  mouseLeaveEven() {
    this.mouseOpen = false;
  }

  /**
   *  根据状态筛选数据
   *  @param searchName 搜索字段
   *  @param info 当前点击数据
   *  @param seData 所有数据
   *  @param index 当前数据属于第几个元素
   */
  searchDataByStatus(searchName, info, seData, index) {
    if (index == 0) { // 点击为全部
      info.selected = true;
      seData['values'].forEach((item, index) => {
        if (index != 0) {
          item.selected = false;
        }
      });
    } else { // 点击为其余
      info.selected = !info.selected;
      if (info.selected) {
        let flag = true;
        for (let q = 0; q < seData['values'].length; q++) {
          // 未选中 不为第一个 不是当前 不为可多选
          if (seData['values'][q].selected && q != 0 && q != index && !seData['values'][q].multiple) {
            seData['values'][q].selected = false;
          }
        }
        if(info.option){
          seData['option'] = info.option;
        }
        seData['values'].forEach((item, key) => {
          if (!item.selected && key != 0 && key != index) {
            flag = false;
          }
        });
        if (flag) {
          seData['values'].forEach((item, key) => {
            if (key != 0) {
              item.selected = false;
            }
          });
          seData['values'][0].selected = flag;
          this.tadpoleSelectData = JSON.parse(JSON.stringify(this.tadpoleSelectData));
        } else {
          seData['values'].forEach((item, i) => {
            if (item.selected && i != index && !item.multiple) {
              item.selected = false;
            }
            if (!info.multiple) {
              if (item.selected && i != index) {
                item.selected = false;
              }
            }
          });
        }
      } else {
        let allSelected = false;
        seData['values'].forEach((item, key) => {
          if (item.selected && key != 0) {
            allSelected = true;
          }
        });
        seData['values'][0].selected = !allSelected;
      }
    }
    this.tadpoleGetData();
  }

  /**
   * add rules data
   * */
  rulesAddData(searchName, seData) {
    let objRules = {
      field: '', // 搜索字段
      option: '', //
      values: [], // 值
      collectIndex: -1,
    };
    objRules.field = searchName;
    objRules.option = seData.option;
    objRules.collectIndex = seData['collectIndex'] == 0 ? seData['collectIndex'] : -1;
    objRules.values = [];
    switch (seData.type) {
      case 'nzTag':
        seData.values.forEach((item, key) => {
          if (key == 0 && item.selected) {
            objRules.values = [];
          } else if (key != 0 && item.selected) {
            objRules.values.push(item.searchCode);
          }
        });
        break;
      case 'date':
        if (this.tadpoleDateData[seData['startDate'].searchName] && this.tadpoleDateData[seData['endDate'].searchName]) {
          objRules.values[0] = formatDate(this.tadpoleDateData[seData['startDate'].searchName], 'yyyy-MM-dd', 'zh') + ' 00:00:00';
          objRules.values[1] = formatDate(this.tadpoleDateData[seData['endDate'].searchName], 'yyyy-MM-dd', 'zh') + ' 23:59:59';
        }
        if (this.tadpoleDateData[seData['startDate'].searchName] && !this.tadpoleDateData[seData['endDate'].searchName]) {
          objRules.values[0] = formatDate(this.tadpoleDateData[seData['startDate'].searchName], 'yyyy-MM-dd', 'zh') + ' 00:00:00';
          objRules.option = 'GEDATE';
        }
        if (!this.tadpoleDateData[seData['startDate'].searchName] && this.tadpoleDateData[seData['endDate'].searchName]) {
          objRules.values[0] = formatDate(this.tadpoleDateData[seData['endDate'].searchName], 'yyyy-MM-dd', 'zh') + ' 23:59:59';
          objRules.option = 'LEDATE';
        }
        break;
      case 'select':
        if (this.tadpoleSearchData[searchName]) {
          objRules.values.push(this.tadpoleSearchData[searchName]);
        } else {
          objRules.values = [];
        }
        break;
      case 'input':
        if (this.tadpoleSearchData[searchName]) {
          objRules.values.push(this.tadpoleSearchData[searchName]);
        } else {
          objRules.values = [];
        }
        break;
      case 'dateInput':
        if (this.tadpoleSearchData[searchName]) {
          objRules.values.push(this.tadpoleSearchData[searchName]);
        } else {
          objRules.values = [];
        }
        break;
      case 'rangeInput':
        if (this.tadpoleSearchData[searchName + '-ge'] && this.tadpoleSearchData[searchName + '-le']) {
          objRules.values[0] = this.tadpoleSearchData[searchName + '-ge'];
          objRules.values[1] = this.tadpoleSearchData[searchName + '-le'];
        }
        if (this.tadpoleSearchData[searchName + '-ge'] && !this.tadpoleSearchData[searchName + '-le']) {
          objRules.values[0] = this.tadpoleSearchData[searchName + '-ge'];
          objRules.values[1] = this.tadpoleSearchData[searchName + '-ge'];
        }
        if (!this.tadpoleSearchData[searchName + '-ge'] && this.tadpoleSearchData[searchName + '-le']) {
          objRules.values[0] = this.tadpoleSearchData[searchName + '-le'];
          objRules.values[1] = this.tadpoleSearchData[searchName + '-le'];
        }

        // if (this.tadpoleSearchData[searchName + '-ge'] && !this.tadpoleSearchData[searchName + '-le']) {
        //   objRules.values[0] = this.tadpoleSearchData[searchName + '-ge'];
        //   objRules.option = 'GEDATE';
        // }
        // if (!this.tadpoleSearchData[searchName + '-ge'] && this.tadpoleSearchData[searchName + '-le']) {
        //   objRules.values[0] = this.tadpoleSearchData[searchName + '-le'];
        //   objRules.option = 'LEDATE';
        // }
        break;
      default:
        objRules.values.push(seData.searchCode);
        break;
    }
    switch (seData.searchType) {
      case 'rangeInput':
        if (this.tadpoleSearchData[searchName + '-ge'] && this.tadpoleSearchData[searchName + '-le']) {
          objRules.values[0] = this.tadpoleSearchData[searchName + '-ge'];
          objRules.values[1] = this.tadpoleSearchData[searchName + '-le'];
        }
        if (this.tadpoleSearchData[searchName + '-ge'] && !this.tadpoleSearchData[searchName + '-le']) {
          objRules.values[0] = this.tadpoleSearchData[searchName + '-ge'];
          objRules.option = 'GEDATE';
        }
        if (!this.tadpoleSearchData[searchName + '-ge'] && this.tadpoleSearchData[searchName + '-le']) {
          objRules.values[0] = this.tadpoleSearchData[searchName + '-le'];
          objRules.option = 'LEDATE';
        }
        break;
    }
    this.resetRulesData(searchName, objRules);
  }

  /**
   * 重组数据 去重
   * */
  resetRulesData(searchName, objRules) {
    if (this.rulesData['rules'].length > 0) {
      for (let i = 0; i < this.rulesData['rules'].length; i++) {
        if (this.rulesData['rules'][i].field == searchName) {
          this.rulesData['rules'].splice(i, 1);
        }
      }
    }
    if (objRules.values[0] && objRules.values.length > 0) {
      this.rulesData['rules'].push(JSON.parse(JSON.stringify(objRules)));
    }
  }

  deliveryDateChange(seData) {
    this.rulesAddData(seData.searchName, seData);
  }

  /** 最大限制添加规则 */
  rangeInputChange(rangeInputData, info?: string) {
    this.rulesAddData(rangeInputData['searchName'], rangeInputData);
    // if (info && this.tadpoleSearchData[rangeInputData['searchName'] + '-ge'] && this.tadpoleSearchData[rangeInputData['searchName'] + '-le']) {
    //   this.tadpoleGetData();
    // }
  }

  forEachData() {
    for (let key in this.tadpoleSearchData) {
      for (let i = 0; i < this.tadpoleSearchTop.length; i++) {
        if (key === this.tadpoleSearchTop[i].searchName) {
          this.tadpoleSearchTop[i]['searchCode'] = this.tadpoleSearchData[key];
          this.rulesAddData(key, this.tadpoleSearchTop[i]);
        }
      }
    }
    this.tadpoleSelectData.forEach((item) => {
      if (item['searchName']) {
        this.rulesAddData(item.searchName, item);
      }
    });
  }

  // 查询
  tadpoleGetData(info?: string) {
    this.loading = true;
    this.number = 1;
    if (info && this.tadpoleSelectData) {
      this.rulesData['rules'] = [];
      for (let k = 0; k < this.tadpoleSelectData.length; k++) {
        if (this.tadpoleSelectData[k].type == 'nzTag') {
          for (let j = 0; j < this.tadpoleSelectData[k].values.length; j++) {
            this.tadpoleSelectData[k].values[0].selected = true;
            if (j != 0) {
              this.tadpoleSelectData[k].values[j].selected = false;
            }
          }
        }
      }

    }
    this.forEachData();
    this.getTadpoleData();
  }

  // 重置
  tadpoleReset() {
    this.tadpoleSearchData = {}; // 搜索字段
    this.tadpoleRangeDate = {};
    this.tadpoleDateData = {};
    this.tadpoleGetData('res');
  }

  /**
   * label-select 清除
   * */
  conSelectChange(info) {
    info.searchName = info.selected.value;
    info.options.forEach((item) => {
      if (item.value != info.searchName) {
        delete this.tadpoleSearchData[item.value];
      }
    });
  }

  // 按钮
  topButtonGroupClick(e, e1?: string) {
    /**刷新*/
    if (e == 'REFRESH_') {
      this.getTadpoleData();
    }
    if (e1) {
      const obj = {
        value: e1,
        code: e,
      };
      this.butGroupClick.emit(obj);
    } else {
      this.buttonGroupClick.emit(e);
    }
  }

  // 跳转
  jumpEvent(e1, e2) {
    const obj = {
      data: e1,
      name: e2,
    };
    this.tableOptionClick.emit(obj);
  }

  // table size 变化
  onSizeTadpoleChange(size) {
    this.loading = true;
    this.getTadpoleData();
  }

  // table page 变化
  onPageTadpoleChange(page) {
    this.loading = true;
    this.number = page;
    this.getTadpoleData();
  }

  // 排序
  onSortChange(sort) {
    this.loading = true;
    if (sort) {
      const key = sort.key;
      const value = sort.value;
      if (value) {
        if (value == 'descend') {
          this.direction = 'DESC';
        }
        if (value == 'ascend') {
          this.direction = 'ASC';
        }
      } else {
        this.direction = 'DESC';
      }
      this.property = key;
    }
    this.number = 1;
    this.getTadpoleData();
  }

  quicklySearchData(e) {
    this.quicklySearData = [];
    this.quicklySearData.push(e);
    this.number = 1;
    this.getTadpoleData();
  }

  /**
   *  获取数据
   * */
  getTadpoleData() {
    this.loading = true;
    this.pageRules = new PageRules({
      direction: this.direction || 'DESC', // 排序
      fromClientType: 'pc',
      number: this.number - 1, // 当前页
      property: this.property || 'createdDate', // 排序字段
      rules: this.rulesData['rules'],
      size: this.size, //当前页数据多少条
      specialConditions: this.quicklySearData,
      workflowSearchBean: this.workflowSearchBean,
    });
    if (!this.workflowSearchBean) {
      delete this.pageRules.workflowSearchBean;
    }
    if (this.fixedRule) {
      if (this.fixedRule.length > 0) {
        let flag = true;
        for (let k = 0; k < this.fixedRule.length; k++) {
          if (this.pageRules.rules.length != 0) {
            for (let i = 0; i < this.pageRules.rules.length; i++) {
              if (this.pageRules.rules[i]['field'] == this.fixedRule[k]['field']) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.pageRules.rules.push(this.fixedRule[k]);
          }
        }
      }
    }
    if (this.pagination) {
      this.loading = false;
      this.jgridPushRules.emit(this.pageRules);
    } else {
      this.tadpoleService.findPage(this.url, this.pageRules).subscribe(info => {
        if (info) {
          this.tadpolePagData = info.content;
          let totalCount = info.totalElements;
          let pageData = new PageData(Number.parseInt(totalCount), this.tadpolePagData);
          this.tadpoleTotalData = pageData;
          this.checkAll(false);
          this.loading = false;
        }
      }, error1 => {
        this.loading = false;
      });
    }

  }

  // 处理name字段 a.b.c 取值问题
  conversionName(data, name) {
    let retanData = '';
    if (name) {
      let colName = name.split('.');
      if (data.hasOwnProperty(colName[0])) {
        if (colName.length > 1) {
          for (let i = 0; i < colName.length; i++) {
            if (i == 0) {
              retanData = data[colName[0]];
            } else {
              if (retanData != null) {
                retanData = retanData[colName[i]];
              } else {
                return retanData = '';
              }
            }
          }
          return retanData == null ? '' : retanData;
        } else {
          return data[colName[0]] == null ? '' : data[colName[0]];
        }
      } else {
        return retanData == null ? '' : retanData;
      }
    } else {
      return retanData == null ? '' : retanData;
    }
  }

  /**全选*/
  checkAll(value: boolean): void {
    if (!this.multipleCheck) {
      return;
    }
    this.tadpoleTotalData.data.forEach(data => {
      if (!data.disabled) {
        data.checked = value;
      }
    });
    this.refreshStatus();
  }

  /** 选中*/
  refreshStatus(): void {
    if (!this.multipleCheck) {
      if (this.selectedRows.length) {
        if (this.selectedRows[0]['checked']) {
          this.selectedRows[0]['checked'] = false;
        }
      }
    }
    this.selectedRows = this.tadpoleTotalData.data.filter(data => data.checked);
    this.selectedLength = { selectedLength: this.selectedRows.length };
    const allChecked = this.tadpoleTotalData.data.filter(value => !value.disabled).every(value => value.checked === true);
    const allUnChecked = this.tadpoleTotalData.data.filter(value => !value.disabled).every(value => !value.checked);
    this.allChecked = allChecked;
    this.indeterminate = (!allChecked) && (!allUnChecked);
    if (this.selectedRows.length > 0) {
      this.selectedRowId = [];
      this.selectedRows.forEach(item => {
        this.selectedRowId.push(item['id']);
      });
    }
    this.checkboxChange.emit(this.selectedRows);
  }

  /**格式化*/
  formatterData(e) {
    if (e) {
      return e.replace(/null/g, '');
    } else {
      return ' ';
    }
  }

  /**按钮类型*/
  getNzType(type, name) {
    return this.flagTypeObj[type][name];
  }

  /**input失去检点*/
  blurData(e) {
    if (e) {
      this.tadpoleGetData();
    }
  }
}

